import React from 'react';
import './MVPPrototyping.css';

const MVPPrototyping = () => {
  return (
    <div className="mvp-container">
      <div className="mvp-hero">
        <h1 className="mvp-title">MVP Prototyping</h1>
        <p className="mvp-subtitle">
          Launch fast, test faster. We help startups and founders bring their product vision to life with high-impact, low-cost MVPs built for real-world validation.
        </p>
      </div>

      <div className="mvp-features">
        <div className="feature-card">
          <h3>Launch in Weeks</h3>
          <p>Our lean development process lets you go from idea to prototype in as little as 2–4 weeks.</p>
        </div>
        <div className="feature-card">
          <h3>Clickable Prototypes</h3>
          <p>Test your concept with interactive UI mockups before writing a single line of code.</p>
        </div>
        <div className="feature-card">
          <h3>Validation Ready</h3>
          <p>Our MVPs are built with core features only — so you can pitch, test, and iterate quickly.</p>
        </div>
        <div className="feature-card">
          <h3>Scalable Foundations</h3>
          <p>All code is production-grade, making it easy to grow your MVP into a full product later.</p>
        </div>
      </div>

      <div className="mvp-cta">
        <h2>Got an MVP in Mind?</h2>
        <p>Use our AI-powered quote generator to receive a tailored plan and timeline instantly.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default MVPPrototyping;
